import type { WebflowItem } from '../types';

interface ItemSelectorProps {
  items: WebflowItem[];
  selectedId: string;
  onChange: (id: string) => void;
  search: string;
  onSearchChange: (value: string) => void;
  isLoading: boolean;
  error: string | null;
  disabled: boolean;
}

export function ItemSelector({
  items,
  selectedId,
  onChange,
  search,
  onSearchChange,
  isLoading,
  error,
  disabled,
}: ItemSelectorProps) {
  return (
    <div className={`card ${disabled ? 'disabled' : ''}`}>
      <h2 className="card-title">
        <span className="step-number">2</span>
        Select Item
      </h2>
      {disabled ? (
        <p className="muted">Select a collection first</p>
      ) : (
        <>
          <div className="search-input-wrapper">
            <input
              type="text"
              className="input"
              placeholder="Search items..."
              value={search}
              onChange={(e) => onSearchChange(e.target.value)}
            />
            {isLoading && <div className="input-spinner" />}
          </div>
          {error ? (
            <p className="error-message">{error}</p>
          ) : (
            <select
              className="select"
              value={selectedId}
              onChange={(e) => onChange(e.target.value)}
              disabled={items.length === 0 && !isLoading}
            >
              <option value="">
                {items.length === 0
                  ? isLoading
                    ? 'Loading items...'
                    : 'No items found'
                  : 'Select an item...'}
              </option>
              {items.map((item) => (
                <option key={item.id} value={item.id}>
                  {item.name}
                  {item.slug ? ` (${item.slug})` : ''}
                </option>
              ))}
            </select>
          )}
          {items.length > 0 && (
            <p className="item-count">{items.length} items found</p>
          )}
        </>
      )}
    </div>
  );
}
